const initialValues = {
    data: {
        freeClause: 'generalClause',
    },
};

export default initialValues;
